module["exports"] = [
  "Jr.",
  "Sr.",
  "I",
  "II",
  "III",
  "IV",
  "V",
  "MD",
  "DDS",
  "PhD",
  "DVM"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/es/name/suffix.js
// module id = 1203
// module chunks = 0